import Vue from 'vue';

const shareState = {
  isShareModalVisible: false,
  showShareModal: false,
  shareMessage: "",
  shareUrl: ""
};

const shareActions = {
  setShowShareModal({ commit }, group) {
    commit("setShowShareModal", group);
  },
  removeShowShareModal({ commit }) {
    commit("removeShowShareModal");
  },
  share(store, { shareUrl, shareMessage }) {
    if (navigator.share) {
      navigator.share({
          // title: "Web Fundamentals",
          text: shareMessage,
          url: shareUrl
        })
        .then(() => console.log("Successful share"))
        .catch(() => {
          store.dispatch('shareDesktop', { shareUrl, shareMessage });
        });
    } else {
      store.dispatch('shareDesktop', { shareUrl, shareMessage });
    }
  },
  shareDesktop(store, { shareUrl, shareMessage }) {
    store.state.shareMessage = shareMessage;
    store.state.shareUrl = shareUrl;
    store.state.isShareModalVisible = true;
  }
};

const shareGetters = {
  showShareModal: state => state.showShareModal,
};

const shareMutations = {
  setShowShareModal(state, group) {
    state.showShareModal = group;
  },
  removeShowShareModal(state) {
    state.showShareModal = false;
  },
  hideShareModal(state) {
    state.isShareModalVisible = false;
  }
  // setChatUnreadCounts(state, { chatId, count }) {
  //   // { ...state.obj, newProp: 123 }
  //   if (state.unreadCounts[chatId]) {
  //     state.unreadCounts[chatId] = count;
  //   } else {
  //     // state.unreadCounts = {...state.unreadCounts, chatId: count };
  //     Vue.set(state.unreadCounts, chatId, count);
  //   }
  // },
};



module.exports = {
  shareState,
  shareActions,
  shareGetters,
  shareMutations
};
